import { StepConnector, stepConnectorClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomStepConnector = styled(StepConnector)(() => ({
  left: "-50%",
  right: "50%",
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    borderColor: "#00BDFF",
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    borderColor: "#00BDFF",
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#326B85",
    borderWidth: 4,
    borderRadius: 5,
    minHeight: 1,
  },
}));

export default CustomStepConnector;